import apiService, { APIResponse } from "./axios";

import { store } from "../../store/store";
import {
  setModules,
  setParameters,
  setTranslations,
} from "../../store/app/general";

class ORMCoreService {
  async fetchModules() {
    const response: APIResponse<any> = await apiService.get<any>(
      "api/rent/configuration/modules",
    );

    if (response.error) {
      console.error("Fehler:", response.message);
      return;
    }

    store.dispatch(setModules(response as any));
  }
  async fetchParameters() {
    const response: APIResponse<any> = await apiService.get<any>(
      "api/rent/configuration/parameters",
    );

    if (response.error) {
      console.error("Fehler:", response.message);
      return;
    }

    store.dispatch(setParameters(response as any));
  }
  async fetchCurrencies() {
    const response: APIResponse<any> = await apiService.get<any>(
      "api/rent/configuration/currencies",
    );

    if (response.error) {
      console.error("Fehler:", response.message);
      return;
    }

    console.log("Modules:", response);
  }
  async fetchInputFields() {
    const response: APIResponse<any> = await apiService.get<any>(
      "api/rent/configuration/input-fields",
    );

    if (response.error) {
      console.error("Fehler:", response.message);
      return;
    }

    console.log("Modules:", response);
  }

  async fetchTranslations() {
    const response: APIResponse<any> = await apiService.get<any>(
      "api/rent/translations",
    );

    if (response.error) {
      console.error("Fehler:", response.message);
      return;
    }

    store.dispatch(setTranslations(response! as any));
  }
}

const ormcoreService = new ORMCoreService();
export default ormcoreService;
